import React from 'react';
import './App.css';
import axios from 'axios';
import PerkCategoryBudgetReport from '../Reports/PerkCategoryBudgetReport';
import ExpenseCategoryBudgetReport from '../Reports/ExpenseCategoryBudgetReport';
import PerkUtilizationReport from '../Reports/PerkUtilizationReport';
import PollsChart from '../Reports/PollsChart';
import EnpsChart from '../Reports/Charts/EnpsChart';
import PerkExpenseBudgetReport from '../Reports/PerkExpenseBudgetReport'
import ActiveInactiveUsers from '../Reports/ActiveInactiveUsers'
import {Dropdown, Checkbox, Button, Loader, Dimmer} from 'semantic-ui-react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';


export default class App extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            reportType: 1,
            selected: false,
            teams: null,
            users: null,
            allTeam: true,
            team: [],
            allEmployee: true,
            employee: [],
            periodSelected: false,
            period: '',
            fromDate: '',
            toDate: '',
            chartPlotted: false,
            isDropdownOpen: false,
            dropdownText: "Budget Allocation: Perk-Category Report",
        }
        this.myRef = React.createRef();
    }

    // doc = () => {
    //     return(<Document>
    //       <Page size="A4">
    //         <div ref={this.myRef} />
            
    //       </Page>
    //     </Document>)
    //   }

    
    async componentDidMount() {

        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        const accessToken = localStorage.getItem('accessToken');
        let API = axios.create({baseURL, headers: {'Authorization': `Bearer ${accessToken}`},});
    
        const teamsResponse = await API.post(`/fetch-teams`, {}).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        this.setState({teams: teamsResponse.data.data})
        this.setState({team: teamsResponse.data.data})

        const employeesResponse = await API.post(`/fetch-employees`, {}).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        this.setState({employee: employeesResponse.data.data})
        this.setState({users: employeesResponse.data.data})
    }

    onChange = (e, data) => {
        this.setState({selected: true});
        
    };

    callChart = () => {
        if(this.state.selected === true){
            if(this.state.reportType === 1){
                return <PerkCategoryBudgetReport allTeam={this.state.allTeam}
                team={this.state.allTeam ? this.state.teams : this.state.team}
                allEmployee={this.state.allEmployee}
                employee={this.state.allEmployee ? this.state.users : this.state.employee} 
                reportType={this.state.reportType}
                />
            }else if(this.state.reportType === 2){
                return <ExpenseCategoryBudgetReport allTeam={this.state.allTeam}
                team={this.state.allTeam ? this.state.teams : this.state.team}
                allEmployee={this.state.allEmployee}
                employee={this.state.allEmployee ? this.state.users : this.state.employee} 
                reportType={this.state.reportType}
                />
            }else if(this.state.reportType === 3){
                return <PerkExpenseBudgetReport allTeam={this.state.allTeam}
                team={this.state.allTeam ? this.state.teams : this.state.team}
                allEmployee={this.state.allEmployee}
                employee={this.state.allEmployee ? this.state.users : this.state.employee} 
                />
            }else if(this.state.reportType === 4){
                return <PerkUtilizationReport />
            }else if(this.state.reportType === 5){
                return <div>No Data Available</div>
            }else if(this.state.reportType === 6){
                return <div>No Data Available</div>
            }else if(this.state.reportType === 7){
                return <PollsChart from={this.state.fromDate} to={this.state.toDate} 
                period={this.state.period} teams={this.state.allTeam ? this.state.teams : this.state.team}
                />
            }else if(this.state.reportType === 8){
                return <EnpsChart />
            }else if(this.state.reportType === 9){
                return <ActiveInactiveUsers allTeam={this.state.allTeam}
                team={this.state.allTeam ? this.state.teams : this.state.team}
                allEmployee={this.state.allEmployee}
                employee={this.state.allEmployee ? this.state.users : this.state.employee}
                />
            }
        }
    }

    ifTeam = () => {
        // if (this.state.allTeam === false){
        const teamsFound = [];
        const dropdownOptions = []
        if (this.state.teams){
            // const teamsFound = [];
            // const dropdownOptions = []
            this.state.teams.forEach(team => {
                // if(team.organizationId === this.state.organizationId){
                    teamsFound.push(team);
                    dropdownOptions.push({key: team._id, text: team.name, value: team._id})
                // }
            });
        }
            return (
                
                < Dropdown
                    placeholder= 'Team'
                    name = 'team'
                    multiple
                    search
                    selection
                    disabled = {this.state.allTeam}
                    style = {{width: `${(this.state.reportType === 4 || this.state.reportType === 5 || this.state.reportType === 6 || this.state.reportType === 7 || this.state.reportType === 8) ? '30%' : '50%'}`, fontFamily: 'SFProText-Regular'}}
                    options={dropdownOptions}
                    onChange = {(e, value) => {
                        this.setState({selected: false});
                        const selection = value.value;
                        const ret = []
                        selection.forEach(teamSelected => {
                            teamsFound.forEach(teamFound => {
                                if(teamSelected === teamFound._id){
                                    ret.push(teamFound);
                                }
                            })
                        })
                        this.setState({team: ret});
                        this.setState({allTeam: false});
                    }} />
            )
        // }
    }

    allEmployees = () => {
        if((this.state.reportType === 4 || this.state.reportType === 5 || this.state.reportType === 6 || this.state.reportType === 7 || this.state.reportType === 8) 
        // && (this.state.team).length !== 0){
            ){
            return (
                <span>
                    <span style={{flex:1, paddingBottom: 20, fontFamily: 'SFProText-Regular'}}>
                        All Employees?
                    </span>
                    <Checkbox toggle
                        // label='All Employees?'
                        checked = {this.state.allEmployee}
                        style = {{paddingLeft: 20, paddingTop: 10}}
                        // disabled = {this.state.allTeam===true ? true: false }
                        onChange = {() => {
                            this.setState((prevState) => ({ allEmployee: !prevState.allEmployee }));
                            this.setState({selected: false});
                        }} 
                    />
                </span>
            )
        }
    }

    ifUser = () => {
        // if (this.state.allEmployee === false && 
        //     this.state.allTeam === false && 
        //     (this.state.reportType === 4 || this.state.reportType === 5) &&
        //     (this.state.team).length !== 0){
            // const usersFound = [];
            // const dropdownOptions = []
        if ((this.state.reportType === 4 || this.state.reportType === 5 || this.state.reportType === 6 || this.state.reportType === 7 || this.state.reportType === 8) && this.state.users){
                const usersFound = [];
                const dropdownOptions = []
                this.state.users.forEach(user => {
                    if(user.role === "perk-manager"){
                        return;
                    }
                    this.state.team.forEach(selectedTeam => {
                        if(user.teamId === selectedTeam._id){
                            usersFound.push(user);
                            dropdownOptions.push({key: user._id, text: user.firstName + " " + user.lastName, value: user._id})
                        }
                    })
                })
            return (
                < Dropdown
                    placeholder= 'User'
                    name = 'user'
                    // fluid
                    multiple
                    search
                    style = {{width: '30%', marginLeft: 20, fontFamily: 'SFProText-Regular'}}
                    selection
                    disabled = {this.state.allEmployee}
                    options={dropdownOptions}
                    onChange = {(e, value) => {
                        const selection = value.value;
                            const ret = []
                            selection.forEach(userSelected => {
                                usersFound.forEach(userFound => {
                                    if(userSelected === userFound._id){
                                        ret.push(userFound);
                                    }
                                })
                            })
                            this.setState({employee: ret});
                            this.setState({allEmployee: false});
                            this.setState({selected: false});
                    }} />
            )
        }else{
            return null;
        }
    }

    periodCheckbox = () => {
        return (
            <span>
                <span style={{flex:1, color: `${!this.state.periodSelected ? 'black' : 'grey'}`}}>
                    Period
                </span>
                <Checkbox slider
                    // label='Period?'
                    checked = {this.state.periodSelected}
                    style={{paddingLeft: 10, paddingRight: 10}}
                    onChange = {() => {
                        this.setState((prevState) => ({ periodSelected: !prevState.periodSelected }));
                        this.setState({selected: false});
                    }} 
                />
            </span>
        )
    }

    checkPeriod = () => {
        return (
                <span>
                    
                    <span style={{flex:4, paddingLeft:20}}>
                        < Dropdown
                            placeholder= 'Select Period'
                            // name = 'Select Period'
                            search
                            closeOnChange
                            style={{width: '10%'}}
                            clearable
                            disabled = {this.state.periodSelected}
                            selection
                            options={[{key: 1, text: 'Past 3 Months', value: 1},
                                    {key: 2, text: 'Past 6 Months', value: 2},
                                    {key: 3, text: 'Past 9 Months', value: 3},
                                    {key: 4, text: 'Past 12 Months', value: 4}]}
                            onChange = {(e, value) => {
                                const selection = value.value;
                                this.setState({period: selection});
                                this.setState({selected: false});
                            }} 
                        />
                    </span>
                </span>
            )
    }

    dateSelect = () => {
        return(<span style={{paddingLeft: 10}}>
            <span style = {{color: `${this.state.periodSelected ? 'black' : 'grey'}`}}>
                From:
            </span>
            <span style={{paddingLeft: 10, width: '10%'}}>
                <SemanticDatepicker 
                    disabled = {!this.state.periodSelected}
                    onChange={(event, data) => {
                        this.setState({fromDate: data.value});
                        this.setState({selected: false});}} />
            </span>
            <span style={{paddingLeft: 10, color: `${this.state.periodSelected ? 'black' : 'grey'}`}}>
                To:
            </span>
            <span style={{paddingLeft: 10, width: '10%'}}>
                <SemanticDatepicker 
                    disabled = {!this.state.periodSelected}
                    minDate = {this.state.fromDate}
                    onChange={(event, data) => {
                        this.setState({toDate: data.value});
                        this.setState({selected: false});}} />
            </span>
        </span>)
    }

    // createPdf = (html) => Doc.createPdf(html);

    render(){
        
        return (
            <div className='App'>
                {(!this.state.teams || !this.state.employee) ? (<Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>)
                :
                <div className='App-header'>
                    <div style={{flex:1, flexDirection: 'column'}}>
                        <div style={{flex:1, flexDirection:'row', padding:10}}>
                            <span style={{flex:1, fontStyle: 'SFProText-Regular'}}>Select Report:</span>
                            <span style={{flex:4, paddingLeft:20}}>

                            <Dropdown 
                                // placeholder= 'Select Report'
                                // name = 'Select Report'
                                closeOnChange
                                style={{width: '50%', fontStyle: 'SFProText-Regular', color: 'black'}}
                                open={this.state.isDropdownOpen}
                                text={this.state.dropdownText}
                                selection
                                onClick={() => {
                                    this.setState({isDropdownOpen: !this.state.isDropdownOpen})
                                }}
                            >
                                    <Dropdown.Menu style={{width: '50%', fontStyle: 'SFProText-Regular', color: 'black'}}>
                                        <Dropdown.Header content="Budget Allocation"></Dropdown.Header>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({valueClicked: true})
                                                                            this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false});
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Allocation: Perk-Category Report"})}} style={{fontStyle: 'SFProText-Regular' }} text="Perk-Category Report" value={1}></Dropdown.Item>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false}); 
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Allocation: Expense-Category Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Expense-Category Report" value={2}></Dropdown.Item>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Allocation: Perk vs Expense Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Perk vs Expense Report" value={3}></Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Header content="Budget Utilization"></Dropdown.Header>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Utilization: Perk-Category Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Perk-Category Report" value={4}></Dropdown.Item>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Utilization: Expense-Category Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Expense-Category Report" value={5}></Dropdown.Item>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Budget Utilization: Perk vs Expense Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Perk vs Expense Report" value={6}></Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Header content="Polls"></Dropdown.Header>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Polls: General Polls Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="General Polls Report" value={7}></Dropdown.Item>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Polls: ENPS Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="ENPS Report" value={8}></Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Header content="Active/Inactive Users"></Dropdown.Header>
                                        <Dropdown.Item onClick={(e, v) => {this.setState({reportType: v.value}); 
                                                                            this.setState({selected: false})
                                                                            this.setState({isDropdownOpen: false}); 
                                                                            this.setState({dropdownText: "Active-Inactive Users Report"})}} style={{fontStyle: 'SFProText-Regular'}} text="Active/Inactive Users/Team Report" value={9}></Dropdown.Item>
                                    </Dropdown.Menu>
                            </Dropdown>
                            </span>
                        </div>

                        <div style={{flex:1, flexDirection: 'row', padding:10}}>
                            <span style={{flex:1, paddingBottom: 20, fontStyle: 'SFProText-Regular'}}>
                                All Teams?
                            </span>
                            <span style={{flex:4, paddingLeft:20, alignSelf: 'center', paddingTop: 5}}>
                                <Checkbox toggle
                                    //label='All Teams?'
                                    checked = {this.state.allTeam}
                                    style={{alignSelf: 'center',}}
                                    onChange = {() => {
                                        this.setState((prevState) => ({ allTeam: !prevState.allTeam }));
                                        if(this.state.allTeam === true){
                                            this.setState({allEmployee: true});
                                        }
                                        this.setState({selected: false});
                                    }}
                                />
                            </span>
                            <span style={{flex:4, flexDirection: 'row', paddingLeft:20}}>
                                {this.ifTeam()}
                            </span>
                            <span style={{flex:4, flexDirection: 'row', paddingLeft:20}}>
                                {this.allEmployees()}
                            </span>
                            <span style={{flex:4, flexDirection: 'row', paddingLeft:20}}>
                                {this.ifUser()}
                            </span>
                        </div>

                        <div style={{flex:1, flexDirection:'row'}}>
                            {!(this.state.reportType === 1 || this.state.reportType === 2 || this.state.reportType === 3 || this.state.reportType === 9) ? 
                                <span>
                                    {this.checkPeriod()}
                                </span>
                            :null}
                            {!(this.state.reportType === 1 || this.state.reportType === 2 || this.state.reportType === 3 || this.state.reportType === 9) ? 
                                <span style={{paddingLeft: 10}}>
                                    {this.periodCheckbox()}
                                    <span style={{paddingLeft: 20}}>
                                        Date Range
                                    </span>
                                </span>
                            :null}
                            {!(this.state.reportType === 1 || this.state.reportType === 2 || this.state.reportType === 3 || this.state.reportType === 9) ?
                                this.dateSelect()
                            :null}
                            <span style = {{paddingLeft: 10}}>
                                <Button
                                    content = "Generate Report"
                                    color = 'green'
                                    disabled = {
                                        !(
                                            ((!this.state.allTeam && (this.state.team).length !== 0) || (this.state.allTeam)) &&
                                            ((this.state.allEmployee) || (!this.state.allEmployee && (this.state.employee).length !== 0)) &&
                                            ((this.state.reportType === 1 || this.state.reportType === 2 || this.state.reportType === 3 || this.state.reportType === 9)||((!this.state.periodSelected && this.state.period !== '') || (this.state.periodSelected && this.state.fromDate !== '' && this.state.toDate !== '')))
                                        )
                                    }
                                    onClick = {this.onChange} />
                            </span>
                        </div>                            
                    </div>
                    <div ref={this.myRef} style={{ paddingTop: 20 }}>
                        {this.callChart()}
                    </div>
                </div>}
            </div>
        );
    }
}
